var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "기본정보" },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.processData,
                              mappingType: _vm.saveType,
                              label: "저장",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveData,
                              btnCallback: _vm.saveCallback,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-dept", {
                      attrs: {
                        label: "팀명(반)",
                        required: true,
                        editable: _vm.editable,
                        name: "deptCd",
                      },
                      model: {
                        value: _vm.processData.deptCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "deptCd", $$v)
                        },
                        expression: "processData.deptCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        required: true,
                        label: "공정명",
                        name: "processName",
                      },
                      model: {
                        value: _vm.processData.processName,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "processName", $$v)
                        },
                        expression: "processData.processName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        label: "원(재)료",
                        name: "mainMaterial",
                      },
                      model: {
                        value: _vm.processData.mainMaterial,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "mainMaterial", $$v)
                        },
                        expression: "processData.mainMaterial",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        type: "number",
                        label: "근로자수(명)",
                        name: "workerCnt",
                      },
                      model: {
                        value: _vm.processData.workerCnt,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "workerCnt", $$v)
                        },
                        expression: "processData.workerCnt",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        label: "생산품(기종)",
                        name: "productName",
                      },
                      model: {
                        value: _vm.processData.productName,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "productName", $$v)
                        },
                        expression: "processData.productName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-1" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        required: true,
                        type: "number",
                        label: "순번",
                        name: "orderNo",
                      },
                      model: {
                        value: _vm.processData.orderNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "orderNo", $$v)
                        },
                        expression: "processData.orderNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-1" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable,
                        isFlag: true,
                        label: "사용여부",
                        name: "useFlag",
                      },
                      model: {
                        value: _vm.processData.useFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "useFlag", $$v)
                        },
                        expression: "processData.useFlag",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "기타 안전보건상 정보" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-accident", {
                      attrs: {
                        editable: _vm.editable,
                        multiple: "",
                        label: "최근 3년간 재해발생사례",
                        name: "accidentHistoryDesc",
                      },
                      model: {
                        value: _vm.processData.accidentHistoryDesc,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "accidentHistoryDesc", $$v)
                        },
                        expression: "processData.accidentHistoryDesc",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-accident", {
                      attrs: {
                        editable: _vm.editable,
                        multiple: "",
                        isNear: true,
                        label: "아차사고사례",
                        name: "nearMissDesc",
                      },
                      model: {
                        value: _vm.processData.nearMissDesc,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "nearMissDesc", $$v)
                        },
                        expression: "processData.nearMissDesc",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable,
                        codeGroupCd: "MDM_PROCESS_WORKER_TYPE_CD",
                        isArray: false,
                        label: "근로자 구성 및 경력특성",
                        name: "workerTypeCd",
                        itemText: "codeName",
                        itemValue: "code",
                      },
                      model: {
                        value: _vm.processData.workerTypeCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "workerTypeCd", $$v)
                        },
                        expression: "processData.workerTypeCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable,
                        codeGroupCd: "MDM_PROCESS_TRANSPORT_TYPE_CD",
                        type: "edit",
                        isArray: false,
                        itemText: "codeName",
                        itemValue: "code",
                        name: "heavyTransportTypeCd",
                        label: "중량물 운반수단",
                      },
                      model: {
                        value: _vm.processData.heavyTransportTypeCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "heavyTransportTypeCd", $$v)
                        },
                        expression: "processData.heavyTransportTypeCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        label: "장비명",
                        name: "heavyTransportEquip",
                      },
                      model: {
                        value: _vm.processData.heavyTransportEquip,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "heavyTransportEquip", $$v)
                        },
                        expression: "processData.heavyTransportEquip",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable,
                        isFlag: true,
                        label: "교대작업 유무",
                        name: "shiftFlag",
                      },
                      model: {
                        value: _vm.processData.shiftFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "shiftFlag", $$v)
                        },
                        expression: "processData.shiftFlag",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable,
                        isFlag: true,
                        label: "중량물 인력취급유무",
                        name: "heavyManualFlag",
                      },
                      model: {
                        value: _vm.processData.heavyManualFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "heavyManualFlag", $$v)
                        },
                        expression: "processData.heavyManualFlag",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable,
                        codeGroupCd: "MDM_PROCESS_HANDLING_TYPE_CD",
                        type: "edit",
                        itemText: "codeName",
                        isArray: false,
                        itemValue: "code",
                        name: "heavyManualTypeCd",
                        label: "취급형태(들기/밀기/끌기)",
                      },
                      model: {
                        value: _vm.processData.heavyManualTypeCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "heavyManualTypeCd", $$v)
                        },
                        expression: "processData.heavyManualTypeCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable,
                        isFlag: true,
                        label: "작업환경측정 실시",
                        name: "workEnvMeasureFlag",
                      },
                      model: {
                        value: _vm.processData.workEnvMeasureFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "workEnvMeasureFlag", $$v)
                        },
                        expression: "processData.workEnvMeasureFlag",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        label: "노출초과인자/수치",
                        name: "exposureOverValue",
                      },
                      model: {
                        value: _vm.processData.exposureOverValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "exposureOverValue", $$v)
                        },
                        expression: "processData.exposureOverValue",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable,
                        codeGroupCd: "RAM_RISK_PROCESS_SPECIAL_EDU_TARGET_CD",
                        type: "edit",
                        isArray: false,
                        itemText: "codeName",
                        itemValue: "code",
                        name: "specialEduTargetCd",
                        label: "특별안전보건교육 해당",
                      },
                      model: {
                        value: _vm.processData.specialEduTargetCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.processData, "specialEduTargetCd", $$v)
                        },
                        expression: "processData.specialEduTargetCd",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "c-table",
            {
              ref: "tableSop",
              attrs: {
                title: "단위작업 목록",
                columns: _vm.gridSop.columns,
                data: _vm.gridSop.data,
                merge: _vm.gridSop.merge,
                columnSetting: false,
                isFullScreen: false,
                usePaging: false,
                editable: _vm.editable,
                gridHeight: "550px",
                selection: "multiple",
                rowKey: "rowId",
              },
              on: {
                innerBtnClicked: _vm.innerBtnClicked,
                "table-data-change": _vm.tableDataChange,
              },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      col.name === "unitWorkName"
                        ? [
                            _c("c-text-column", {
                              attrs: {
                                editable: _vm.editable,
                                col: col,
                                props: props,
                              },
                              on: {
                                datachange: function ($event) {
                                  return _vm.datachange(props, col)
                                },
                              },
                            }),
                            _vm.editable
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "q-btn-group",
                                      {
                                        staticClass: "ColumInnerBtnGroup",
                                        attrs: { outline: "" },
                                      },
                                      [
                                        _c(
                                          "q-btn",
                                          {
                                            staticClass: "ColumInnerBtn",
                                            attrs: {
                                              icon: "add",
                                              color: "light-blue",
                                              "text-color": "white",
                                              align: "center",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.innerBtnClicked(
                                                  col,
                                                  props
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("q-tooltip", [
                                              _vm._v("단위작업 추가"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        : col.name === "equipName"
                        ? [
                            _c("c-text-column", {
                              attrs: {
                                editable: _vm.editable,
                                col: col,
                                props: props,
                              },
                              on: {
                                datachange: function ($event) {
                                  return _vm.datachange(props, col)
                                },
                              },
                            }),
                            _vm.editable
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "q-btn-group",
                                      {
                                        staticClass: "ColumInnerBtnGroup",
                                        attrs: { outline: "" },
                                      },
                                      [
                                        _c(
                                          "q-btn",
                                          {
                                            staticClass: "ColumInnerBtn",
                                            attrs: {
                                              icon: "add",
                                              color: "green-6",
                                              "text-color": "white",
                                              align: "center",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.innerBtnClicked(
                                                  col,
                                                  props
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("q-tooltip", [
                                              _vm._v("설비 추가"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        : col.name === "chemName"
                        ? [
                            _c("c-text-column", {
                              attrs: {
                                editable: _vm.editable,
                                col: col,
                                props: props,
                              },
                              on: {
                                datachange: function ($event) {
                                  return _vm.datachange(props, col)
                                },
                              },
                            }),
                            _vm.editable
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "q-btn-group",
                                      {
                                        staticClass: "ColumInnerBtnGroup",
                                        attrs: { outline: "" },
                                      },
                                      [
                                        _c(
                                          "q-btn",
                                          {
                                            staticClass: "ColumInnerBtn",
                                            attrs: {
                                              icon: "add",
                                              color: "deep-orange",
                                              "text-color": "white",
                                              align: "center",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.innerBtnClicked(
                                                  col,
                                                  props
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("q-tooltip", [
                                              _vm._v("화학물질 추가"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              showLoading: false,
                              label: "단위작업 추가",
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addWork },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              showLoading: false,
                              label: "제외",
                              icon: "remove",
                            },
                            on: { btnClicked: _vm.removeRow },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }